import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  MessageResult,
} from 'common/repositories/common.model';

import { CheckApprovalReleaseUserModel, RefundReleaseUserInput } from './model';

export function useReleasingRefundReleaseUser(
  options?: UseMutationOptions<MessageResult, ApiError, RefundReleaseUserInput>,
): UseMutationResult<MessageResult, ApiError, RefundReleaseUserInput> {
  return useMutation<MessageResult, ApiError, RefundReleaseUserInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `release-sales/${body.releaseSaleId}/release`,
        method: 'POST',
      });
    },
    options,
  );
}

export function useCheckApprovalRefundReleaseUser(
  options?: UseMutationOptions<
    ApiResult<CheckApprovalReleaseUserModel>,
    ApiError,
    RefundReleaseUserInput
  >,
): UseMutationResult<
  ApiResult<CheckApprovalReleaseUserModel>,
  ApiError,
  RefundReleaseUserInput
> {
  return useMutation<
    ApiResult<CheckApprovalReleaseUserModel>,
    ApiError,
    RefundReleaseUserInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `release-sales/${body.releaseSaleId}/check-approval`,
      method: 'POST',
      classType: CheckApprovalReleaseUserModel,
    });
  }, options);
}
